/*
 * @providesModule MatchSelectListSection
 */

import _ from 'lodash';
import Tournament from 'SKZTournament';
import ClientPropertyConstants from 'ClientPropertyConstants';

export default class MatchSelectListSection {
  type: string;
  data: Array<Tournament>;
  name: string;
  description: string;
  length: number;
  enableAccordion: boolean;
  _id: number;

  constructor(keyValueSource: Object) {
    return _.create(MatchSelectListSection.prototype, keyValueSource);
  }

  hasDuplicate(tournament: Tournament): boolean {
    if (tournament == null) {
      return false;
    }

    let tournamentsEqual = (tournamentA: Tournament, tournamentB: Tournament): boolean => {
      return tournamentA.id == tournamentB.id;
    };

    if (this.type == 'FRIENDS') {
      tournamentsEqual = (tournamentA: Tournament, tournamentB: Tournament): boolean => {
        if (tournamentA.isIncomingInvite() != tournamentB.isIncomingInvite()) {
          return false;
        }

        if (tournamentA.isIncomingInvite()) {
          return tournamentA.match_code == tournamentB.match_code;
        } else {
          return tournamentA.id == tournamentB.id;
        }
      };
    }

    let hasDuplicate = false;
    _.forEach(this.data, (obj: Tournament) => {
      if (tournamentsEqual(obj, tournament)) {
        hasDuplicate = true;
      }
    });

    return hasDuplicate;
  }

  hasData(): boolean {
    return this.data.length > 0;
  }

  containsLiveBracket(): boolean {
    let shouldRefresh = false;
    if (this.type == 'LIVE_BRACKET' && this.hasData()) {
      _.forEach(this.data, (obj: Tournament) => {
        if (obj.bracket) {
          shouldRefresh = true;
        }
      });
    }

    return shouldRefresh;
  }

  configureAccordionForRecommendedTemplate(recommendedTournamentCount: number) {
    this.enableAccordion = recommendedTournamentCount > 1;
  }

  configureAccordion(category: Object) {
    if (this.type == 'LIVE' || (this.type != 'FRIENDS' && this.length > 1)) {
      this.enableAccordion = true;
    }

    if (this.type == 'FRIENDS') {
      this.enableAccordion = this.numberOfIncomingFriendInvites(category.tournaments) > 1;
    }

    if (this.type == 'LIVE' && ClientPropertyConstants.getMatchCodeVisibilityEnabled()) {
      this.enableAccordion = this.length > 1;
    }
  }

  numberOfIncomingFriendInvites(data: Array<Tournament>): number {
    let count = 0;
    _.forEach(data, (tournament) => {
      if (tournament.isIncomingInvite()) {
        count++;
      }
    });
    return count;
  }

  containsIncomingFriendInvite(): boolean {
    return this.numberOfIncomingFriendInvites(this.data) > 0;
  }
}
